import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProspektrApi {
  private logOut = 'logOut';
  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  private weatherTemperatureApiKey = environment.weatherTemperatureApiKey;
  private weatherTemperatureApiUrl = environment.weatherTemperatureApiUrl;
  private agentIdList = 'agentIdList';
  private agentMlsApi = 'agentMls';
  private getDefaultSignupConfigApi = 'getDefaultSignupConfig';
  private appraisersMlsApi = 'getAppraisersMlsData';
  private connectedAgentSMlsApi = 'getConnectedAgentsMlsData';
  private brandingPartnerApi = 'brandingPartner';
  private businessAreaApi = 'business-areas';
  private campaignUsersApi = 'campaignUsers';
  private clientApi = 'client';
  private brandApi = 'brand';

  private associationBoard = 'association-boards';
  private connection = 'connection';
  private contactAgentApi = 'contactAgent';
  private contactApi = 'contact-groups';
  private contactLenderApi = 'contactLender';
  private contacts = 'contacts';
  private contactUploads = 'contacts/upload';
  private dealAnalysisByAddressApi = 'dealAnalysisByAddress';
  private deleteDealApi = 'dealAnalysis';
  private deleteMortgageApi = 'mortgage';
  private deletePropertyAlertApi = 'deletePropertyAlert';
  private getAllPropertyAlertApi = 'propertyAlert';
  private getCampaignListApi = 'campaigns';
  private getAgentMarketingCampaignListApi = 'agentMarketingCampaigns';
  private updateLeadForAutomatedCampApi = 'updateLeadForAutomatedCamp';
  private getClientInfoByIdApi = 'getClientInfoById';
  private getConnectionInfoByUserTokenApi = 'connectionByUserToken';
  private getDealListApi = 'dealAnalysis';
  private getLoggedActivitiesApi = 'activityLog';
  private getPropertyValuesApi = 'getPropertyValues';
  private getSavedDealsApi = 'savedDealAddress';
  private getUnreadPropertyAlertApi = 'unReadPropertyAlert';
  private interestedAreaApi = 'interestedArea';
  private inviteUserApi = 'inviteUser';
  private inviteLoanOfficerApi = 'inviteLoanOfficer';
  private inviteEmployeeApi = 'inviteEmployee';
  private addAgentLoanOfficerApi = 'addAgentLoanOfficer';
  private inviteAppraiserApi = 'inviteAppraiser';
  private logActivityApi = 'logActivity';
  private userActivityApi = 'userActivity';
  private myHomeApi = 'myHome';
  private partnersApi = 'partners';
  private planUpgradeRequestApi = 'planUpgrade';
  private reportApi = 'report';
  private saveDealApi = 'dealAnalysis';
  private setAsDefaultPartnerApi = 'defaultConnection';
  private signupContinueApi = 'signupContinue';
  private signupInvitedUserApi = 'signupInvitedUser';
  private updateDealApi = 'dealAnalysis';
  private updateOnboardRequestApi = 'updateOnboardRequest';
  private getEmailTemplateApi = 'getEmailTemplate';
  private uploadToS3Api = 'uploadToS3';
  private getDomainsApi = 'getDomains';
  private userAuthenticateApi = 'userAuthenticate';
  private socialMediaSignInApi = 'socialMediaSignIn';
  private preApprovalApi = 'preApproval';
  private questionnaireResponseApi = 'questionnaireResponse';
  private connectedAgents = 'getConnectedAgents';
  private listMyHome = 'notifyListMyHome';
  private signUp = 'signUp';
  private verifyPhoneNumberApi = 'verifyPhoneNumber';
  private validateOTPApi = 'verifyOTP';
  private getExpiredListings = 'GetListingsByAgent'
  private getAgentListings = 'getAgentListings'
  private fetchExpiredListing = 'getExpiredListings';
  private updateExpiredOwnerDetails = 'updateExpiredListingsOwnerDetails'
  private getMorgageHistoryList = 'getMortgageHistory'
  private equityAnalysis = 'equityAnalysis'
  private saveEquityAnalysis = 'saveEquityAnalysis'
  private savdEquityAnalysis = 'savedEquityAnalysis'
  private getEquityAnalysisById = 'equityAnalysisById'
  private deleteEquityAnalysisById = 'deleteEquityAnalysisById'
  constructor(private http: HttpClient) { }

  loginUsers(param): Observable<any> {
    const encodedEmail = encodeURIComponent(param.email);
    return this.http.get(`${this.prospektrBackendBaseURL}users/company`, {
      params: { email: encodedEmail },
    });
  }

  userAuthenticate(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.userAuthenticateApi}`, {
      userName: params.email,
      password: params.password,
      companyId: params.companyId,
    });
  }

  socialMediaSignIn(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.socialMediaSignInApi}`, params);
  }

  signUpForAgentLoanOfficer(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.signUp}`, params);
  }

  uploadToS3(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.uploadToS3Api}`, params).pipe(retry(1));
  }

  getSuggestedDomains(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getDomainsApi}`, params).pipe(retry(1));
  }

  uploadDocumentToS3(params): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
      }),
    };
    return this.http.post(`${this.prospektrBackendBaseURL}documentUploadToS3`, params, httpOptions).pipe(retry(1));
  }

  createUser(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}signupUser`, params);
  }

  preapprovalAction(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.preApprovalApi}`, params);
  }

  signUpContinue(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.signupContinueApi}`, params);
  }

  getCampaignList(params?): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getCampaignListApi}`, {
      params: params,
    });
  }

  getAgentMarketingCampaignList(params?): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getAgentMarketingCampaignListApi}`, params);
  }

  updateLeadForAutomatedCamp(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.updateLeadForAutomatedCampApi}`, params);
  }

  updateCampaign(campaignId, campaign): Observable<any> {
    return this.http.patch(`${this.prospektrBackendBaseURL}campaigns/${campaignId}`, campaign);
  }

  deleteCampaign(campaignId: string): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}campaigns/${campaignId}`);
  }

  createCampaign(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}campaigns`, params);
  }

  launchCampaign(campaignId: string, frequency: string = null, sendImmediately): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}campaigns/${campaignId}/launch`, {
      params: { frequency, sendImmediately },
    });
  }

  getCampaignCandidates(campaignId: string): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}campaigns/${campaignId}/candidates`);
  }

  createCampaignUsers(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.campaignUsersApi}`, params);
  }

  launchAutomatedCampaign(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}launchAutomatedCampaign`, params);
  }

  getClientInfoById(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getClientInfoByIdApi}`, params);
  }

  getClientInfoByUserToken(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getConnectionInfoByUserTokenApi}`);
  }

  getEmailTemplate(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getEmailTemplateApi}`, params);
  }

  updateOnboardRequest(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.updateOnboardRequestApi}`, params);
  }

  signupInvitedUser(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.signupInvitedUserApi}`, params);
  }

  planUpgradeRequest(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.planUpgradeRequestApi}`, params);
  }

  campaignOnboard(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}campaign-onboard/${params}`);
  }

  listAddressCsvRecord(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.contactApi}/${params}/${this.contacts}`);
  }


  acceptPartnerInvitation(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}partner/acceptInvitation`, params);
  }

  contactsList(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}contact-group-list`, params);
  }

  selectedContacts(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}contact-selected-list`, params);
  }

  campaignInfo(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}campaign-statistics`, params);
  }

  agentMarketingCampaignInfo(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}agent-marketing-campaign-statistics`, params);
  }

  agentMarketingCampaignStatisticsExport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}agent-marketing-campaign-statistics/export-csv`, params, {
      responseType: 'text',
    });
  }

  campaignReadInfo(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}campaign-mkt-statistics`, params);
  }

  reportInfo(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}report-info`, params);
  }

  addContactList(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}contact-list`, params);
  }

  createAutomatedContact(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}createAutomatedContacts`, params);
  }

  getDealList(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getDealListApi}`, {
      params: params,
    });
  }

  getDealById(id) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getDealListApi}/${id}`);
  }

  updateDeal(params): Observable<any> {
    return this.http.patch(`${this.prospektrBackendBaseURL}${this.updateDealApi}`, params);
  }

  deleteDeal(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.deleteDealApi}`, {
      params: params,
    });
  }

  saveDeal(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.saveDealApi}`, params);
  }

  logActivity(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.logActivityApi}`, params);
  }

  userActivity(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.userActivityApi}`, params);
  }

  fetchInvestors(params?) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors`, params);
  }

  fetchInvestorsUnderMarketingEffectiveness(params?) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/marketingEffectiveness`, params);
  }

  fetchEmailDetails(params?) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/marketingHistory`, params);
  }

  fetchClientDetailsUnderMarketing(params?) {
    const requestBody = params;
    return this.http.post(`${this.prospektrBackendBaseURL}investors/marketingStatistics`, requestBody);
  }

  fetchAgentsAndLoanOfficers(params = {}) {
    return this.http.post(`${this.prospektrBackendBaseURL}client-users`, params);
  }
  fetchAddedAgentsAndLoanOfficers(params = {}) {
    return this.http.post(`${this.prospektrBackendBaseURL}getUsers`, params);
  }

  fetchAllActiveUsers(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}exportMostActiveUsers`, params);
  }

  getSavedDeals(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getSavedDealsApi}`, {
      params: params,
    });
  }

  getLoggedActivities(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getLoggedActivitiesApi}`, {
      params: params,
    });
  }

  getSentMails(investorId) {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/${investorId}/mail`);
  }

  addSavedSearch(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/${params.investorId}/saved-searches`, params);
  }

  getUnReadPropertyAlert(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getUnreadPropertyAlertApi}`, {
      params: params,
    });
  }

  getPropertyAlert(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getAllPropertyAlertApi}`, {
      params: params,
    });
  }

  deleteAlert(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.deletePropertyAlertApi}`, params);
  }

  dealAnalysisByAddress(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.dealAnalysisByAddressApi}`, {
      params: params,
    });
  }

  getAgentMls(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.agentMlsApi}`);
  }

  getSignupConfig(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getDefaultSignupConfigApi}`);
  }

  getAppraisersMlsList(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.appraisersMlsApi}`);
  }

  getConnectedAgentsMlsList(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.connectedAgentSMlsApi}`);
  }

  getMLSBoards(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}mls-boards`, {
      params: params,
    });
  }

  saveAgentMls(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.agentMlsApi}`, params);
  }

  deleteAgentMls(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.agentMlsApi}`, {
      params: params,
    });
  }

  verifyPhoneNumber(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.verifyPhoneNumberApi}`, params);
  }

  validateOTP(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.validateOTPApi}`, params);
  }

  createBusinessAreas(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.businessAreaApi}`, params);
  }

  getBusinessAreas(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.businessAreaApi}`);
  }

  deleteBusinessArea(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.businessAreaApi}/${params}`);
  }

  fetchActivePartners(params?) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.partnersApi}`, params);
  }

  setAsDefaultPartner(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.setAsDefaultPartnerApi}`, params);
  }

  inviteAppraiser(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.inviteAppraiserApi}`, params);
  }

  inviteLoanOfficer(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.inviteLoanOfficerApi}`, params);
  }

  inviteEmployee(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.inviteEmployeeApi}`, params);
  }
  addAgentLoanOfficer(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.addAgentLoanOfficerApi}`, params);
  }

  inviteUser(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.inviteUserApi}`, params);
  }

  inviteInvestor(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}campaigns/investor-invitation`, params);
  }

  downloadAttchment(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/${params.id}/download`, params);
  }

  getBrandingPartnersInfo(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.brandingPartnerApi}`, {
      params: params,
    });
  }

  getInterestedArea(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.interestedAreaApi}`);
  }

  createInterestedArea(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.interestedAreaApi}`, params);
  }

  deleteInterestedArea(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.interestedAreaApi}`, {
      params: params,
    });
  }

  uploadContacts(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.contactUploads}`, params);
  }

  getContactGroups(contactId?: string, params?: any) {
    let getContactUrl = this.contactApi;
    if (contactId) {
      getContactUrl += '/' + contactId;
    }

    return this.http.get(`${this.prospektrBackendBaseURL}${getContactUrl}`, {
      params,
    });
  }

  getAutomatedContactGroups(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}getAutomatedContacts`, params);
  }

  deleteContactFileList(idList) {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.contactApi}/${idList}`);
  }

  updateCmaConfiguration(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}updateCmaConfiguration`, params);
  }

  getCmaConfiguration(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}getCmaConfiguration`);
  }

  getClient(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.clientApi}`);
  }

  getBrandInfo(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.brandApi}`);
  }

  getUserPortfolio(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}user/portfolio`);
  }

  updatePortfolio(params) {
    return this.http.put(`${this.prospektrBackendBaseURL}user/portfolio`, params);
  }

  getAssociation(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.associationBoard}`, {
      params: params,
    });
  }

  uploadImage(file): Observable<any> {
    const formData = new FormData();
    formData.append('image', file, file.name);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
      }),
    };
    return this.http.post(`${this.prospektrBackendBaseURL}misc/image-upload`, formData, httpOptions);
  }

  sentMail(file, id): Observable<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'multipart/form-data',
    //   }),
    // };
    return this.http.post(`${this.prospektrBackendBaseURL}investors/${id}/mail`, file);
  }

  sendPastClientMail(file): Observable<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'multipart/form-data',
    //   }),
    // };
    return this.http.post(`${this.prospektrBackendBaseURL}pastClient/mail`, file);
  }

  patchClient(clientId, params): Observable<any> {
    return this.http.patch(`${this.prospektrBackendBaseURL}${this.clientApi}/${clientId}`, params);
  }

  patchBrandInfo(userId, params): Observable<any> {
    return this.http.patch(`${this.prospektrBackendBaseURL}${this.brandApi}/${userId}`, params);
  }

  updateCampaignUsers(params): Observable<any> {
    return this.http.put(`${this.prospektrBackendBaseURL}${this.campaignUsersApi}`, params);
  }

  getHomeList() {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.myHomeApi}`);
  }

  saveHome(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.myHomeApi}`, params);
  }

  notifyListMyHome(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.listMyHome}`, params);
  }

  getPropertyValues(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getPropertyValuesApi}`, {
      params: params,
    });
  }

  updateMyHome(params) {
    return this.http.patch(`${this.prospektrBackendBaseURL}${this.myHomeApi}`, params);
  }

  getWeather(lat: number, lng: number) {
    return this.http.get(
      `${this.weatherTemperatureApiUrl}?key=${this.weatherTemperatureApiKey}&q=${lat},${lng}&aqi=no`
    );
  }

  deleteMyHome(id) {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.myHomeApi}/${id}`);
  }

  deleteMyHomeSubscription(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}deleteSubscription`, params);
  }

  contactAgentInfo() {
    return this.http.get(`${this.prospektrBackendBaseURL}agentDetails`);
  }

  contactAgent(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.contactAgentApi}`, params);
  }

  notifyContactAgent(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}notifyAgent`, params);
  }

  contactLender(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.contactLenderApi}`, params);
  }

  deleteMortgage(id) {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.deleteMortgageApi}/${id}`);
  }

  getReport(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.reportApi}`, {
      params: { ...params, limit: params.limit || 10, offset: params.offset || 0 },
    });
  }

  getAgentIdList(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.agentIdList}`);
  }

  updateLeadStatus(investorId, params) {
    return this.http.patch(`${this.prospektrBackendBaseURL}investors/${investorId}/lead`, params);
  }

  updateInvestorConnection(investorId, params) {
    return this.http.patch(`${this.prospektrBackendBaseURL}investors/${investorId}/connection`, params);
  }

  getMyHomeProperties(investorId) {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/${investorId}/myHomeProperties`);
  }

  getUsersNote(investorId) {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/${investorId}/notes`);
  }

  addUserNote(investorId, params) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/${investorId}/notes`, params);
  }

  updateUserNote(noteId, params) {
    return this.http.patch(`${this.prospektrBackendBaseURL}investors/notes/${noteId}`, params);
  }

  deleteUserNote(noteId) {
    return this.http.delete(`${this.prospektrBackendBaseURL}investors/notes/${noteId}`);
  }

  resendActivationMail(investorId) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/${investorId}/signUpReminder`, null);
  }

  getConnectionDetail(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/${params}/${this.connection}`);
  }

  leadLogCountDetail() {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/statistics`);
  }

  getDashboardCount() {
    return this.http.post(`${this.prospektrBackendBaseURL}getDashboardCount`, null);
  }

  checkUserDetails() {
    return this.http.post(`${this.prospektrBackendBaseURL}checkUserDetails`, null);
  }

  exportMyClientsToCSV(params?) {
    return this.http.post(`${this.prospektrBackendBaseURL}investors/export`, params);
  }

  exportUserListToCSV(params: any): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}exportUsers`, {
      params: params,
    });
  }

  exportAddedUserListToCSV(params: any): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}exportAddedUsers`, {
      params: params,
    });
  }

  updateUnsubscribeRecommendation(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}subscription/unsubscribe`, params);
  }

  unsubscribeFeature(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}unsubscribeFeature`, { params: params });
  }

  getMyListings(params: any): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}investors/myListings`, {
      params: params,
    });
  }

  getPlans(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}plans`, { params: params });
  }

  getConnectedUsers(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}connectedUsers`);
  }

  getConnectedAgents(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.connectedAgents}`);
  }

  applyCode(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}feature/apply-coupon`, { params: params });
  }

  subscribePlan(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}feature/subscribe`, params);
  }

  logOutUser(): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.logOut}`, null).pipe(catchError(() => EMPTY));
  }
  getQuestionnaireResponse(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.questionnaireResponseApi}`);
  }

  addSellerProperty(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}addSellerProperty`, params);
  }

  getAddContactPastClient(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}getPastClientContact`, params);
  }

  launchPastClientAutomatedCampaign(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}launchPastClientAutomatedCampaign`, params);
  }

  getAutomatedCampSubscriptions(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}getAutomatedCampSubscriptions`, params);
  }

  deleteSubscription(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}deleteSubscription`, params);
  }

  subscribeBundles(payload) {
    return this.http.post(`${this.prospektrBackendBaseURL}feature/bundles/subscribe`, payload);
  }

  previewPlan(payload: { planId: string; promoCode?: string }) {
    return this.http.post(`${this.prospektrBackendBaseURL}feature/plan/preview`, payload);
  }

  previewBundles(payload: { bundleIds: string[] }) {
    return this.http.post(`${this.prospektrBackendBaseURL}feature/bundles/preview`, payload);
  }

  applyCoupon(payload: { planId: string; promoCode: string }) {
    return this.http.get(`${this.prospektrBackendBaseURL}feature/apply-coupon`, {
      params: payload as any,
    });
  }
  updateExpiredListingsForAgent(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getExpiredListings}`, params);
  }

  fetchAgentListings(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getAgentListings}`, { params: params });
  }

  fetchExpiredListingsForAgent(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.fetchExpiredListing}`, { params: params });
  }

  updateExpiredListingsOwnerData(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.updateExpiredOwnerDetails}`, params);
  }
  decryptClientData(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}decrypt/client`, params);
  }

  getMortgageHistory(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getMorgageHistoryList}`, params);
  }

  getEquityAnalysis(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.equityAnalysis}`, params);
  }

  saveEquityAnalysisData(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.saveEquityAnalysis}`, params);
  }
  getSavedEquityAnalysisData(params) {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.savdEquityAnalysis}`, params);
  }

  fetchEquityAnalysisById(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getEquityAnalysisById}`, { params: params });
  }

  deleteEquityAnalysisDataById(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.deleteEquityAnalysisById}`, { params: params });
  }
}
